const val = localStorage.getItem('food-delivery-token');
export const token = localStorage.getItem('food-delivery-token')